<template>
    <div>
        <h6 class="heading-small text-muted mb-4">Order Items</h6>

        <display-order-items
            :order-items="orderItems"
            @toggleAssignment="hideTotals = $event"
            @view-item="setItemView"
        />

        <view-item ref="viewItem" :order-id="order_id" />

        <div>
            <b-row v-if="orderItems.length != 0 && (!viewMode || !hideTotals)">
                <b-col cols="9">
                    <b class="float-right">Total</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <b>${{ orderPricing.total | currency }}</b>
                </b-col>
            </b-row>

            <b-row v-if="orderItems.length != 0 && (!viewMode || !hideTotals)">
                <b-col cols="9">
                    <b class="float-right">Total Tax</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <span>${{ orderPricing.tax | currency }}</span>
                </b-col>
            </b-row>

            <b-row v-if="orderItems.length != 0 && (!viewMode || !hideTotals)">
                <b-col cols="9">
                    <b class="float-right">Grand Total</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <b
                        >${{
                            (orderPricing.tax + orderPricing.total) | currency
                        }}</b
                    >
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <a
                        v-if="
                            orderItems.length > 0 && orderItems.some(x => x.id)
                        "
                        :href="reportURL"
                        target="_blank"
                        >Download PDF</a
                    >
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import DisplayOrderItems from './DisplayOrderItems'
import popupMixins from '@/mixins/popupMixins'

import ViewItem from './ViewItem'
const rpt_type = 'statement'
export default {
    name: 'OrderItems',
    components: {
        DisplayOrderItems,
        ViewItem,
    },
    mixins: [popupMixins],
    data() {
        return {
            submitting: false,
            hideTotals: false,
        }
    },
    props: ['viewMode', 'orderId'],
    filters: {
        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        displayTypeName(id, types) {
            console.log('types', types)
            return (types.find(x => x.id == id) || {}).name
        },
    },

    computed: {
        order_id() {
            return this.orderId || this.$route.params.id
        },
        itemTypeOptions() {
            return this.itemTypes.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },

        orderItems() {
            return this.$store.state.orders.orderItems
        },
        order() {
            return this.$store.state.orders.item
        },
        itemTypes() {
            return this.$store.state.itemType.items
        },
        reportURL() {
            const url = this.$store.getters['js_report/reportUrl']
            if (url) return url + '&id=' + this.order_id
            else return null
        },

        orderPricing() {
            console.log('this.orderItems', this.orderItems)
            return this.orderItems.reduce(
                (_pricing, item) => {
                    if (!item.deleted) {
                        let itemCost =
                            (parseFloat(item.price) || 0) *
                            (parseFloat(item.quantity) || 1)
                        _pricing.total += itemCost
                        _pricing.tax +=
                            (itemCost * (parseFloat(item.tax_rate) || 0)) / 100
                    }
                    return _pricing
                },
                { tax: 0, total: 0 }
            )
        },
    },

    mounted() {
        this.$store.dispatch('assets/fetch')
        this.$store.dispatch('locations/fetchWarehouses')
        this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('orders/fetchOrderItems', this.order_id)
        //this.$store.dispatch('orders/fetchById', id)

        console.log('mounted order_id', this.orderId)

        this.$store.dispatch('js_report/fetchCredentials', rpt_type)
    },

    methods: {
        setItemView(id) {
            console.log('id', id)

            const item = {
                ...(this.orderItems.find(x => x.id === id) || {}),
            }
            this.$refs['viewItem'].showItem(item)
        },

        async updateOrderItem(items) {
            try {
                this.submitting = true
                const id = this.order_id
                const total = this.orderPricing.total
                console.log('items', items)
                await this.$store.dispatch('orders/updateOrderItems', {
                    id,
                    items,
                    total,
                })
                //await this.$store.dispatch('report/getStatement', id)
                this.$store.dispatch('js_report/fetchCredentials', rpt_type)
            } catch (error) {
                this.doToast(
                    'Error!',
                    error.response.data.error.message,
                    'danger'
                )
            } finally {
                this.submitting = false
            }
        },
    },
}
</script>
